import { useGame } from '@/store/game';
import { MainAction } from '@/ui/MainAction';

const RULES = [
  '3–8 человек в круге. Телефон идёт по часовой',
  'Тянешь карту — выполняешь или пропускаешь',
  'Карта Клоуна не пропускается. Никогда',
];

/**
 * 01 · Возрастной гейт (design-spec.md). Показывается один раз — флаг живёт
 * в сторе (`ageVerified`/`acceptAge`) и пишется в localStorage автоматически
 * (src/store/storage.ts), здесь об этом заботиться не нужно.
 */
export function GateScreen() {
  const acceptAge = useGame((s) => s.acceptAge);

  return (
    <div
      className="flex min-h-screen flex-col bg-ground px-5 text-ink"
      style={{ paddingTop: 'var(--clown-safe-top)' }}
    >
      <div className="flex flex-1 flex-col justify-between gap-8 py-6">
        <div>
          <h1 className="font-display text-hero">КЛОУН</h1>
          <p className="mt-3 font-display text-meta uppercase text-acc">
            ИГРА ДЛЯ ТЕХ, КОМУ МОЖНО
          </p>
        </div>

        <ul className="flex flex-col gap-rule border-2 border-line bg-line">
          {RULES.map((rule) => (
            <li key={rule} className="bg-panel px-4 py-4 text-base text-ink">
              {rule}
            </li>
          ))}
        </ul>

        <div>
          <p className="font-display text-gate text-acc">18+</p>
          <p className="mt-3 text-base text-dim">
            Внутри алкоголь, откровенные вопросы и задания, которые не стоит показывать детям.
          </p>
        </div>
      </div>

      <div className="-mx-5" style={{ paddingBottom: 'var(--clown-safe-bottom)' }}>
        <MainAction text="МНЕ ЕСТЬ 18" onPress={acceptAge} />
      </div>
    </div>
  );
}
